import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import EditableInfo from "../../../EditableInfo";
import { EditableProps } from "../../../editableProps";
import Toggle from "@builder/components/general/Toggle";
import OliverText from "@builder/components/general/OliverText";
import { updatePaymentGridSettings } from "@builder/store/slices/BuilderSlice/builderSlice";
import "./style.scss";
import Info from "../../Info";

const EditPaymentGrid = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const paymentSettings = useAppSelector(state => state.builder.build.paymentGridSettings);

    return (
        <SidebarCollapse title="Payment grid" parent={parent}>
            <EditableInfo header="paymentGridHeader" body="paymentGridBody1" body2="paymentGridBody2" />

            <Toggle
                label="Allow custom by company"
                checked={paymentSettings?.allowCustom || false}
                callback={() => dispatch(updatePaymentGridSettings({ type: "allowCustom", setting: !paymentSettings?.allowCustom }))}
            />

            <OliverText
                style={{ maxWidth: "85%" }}
                size="xxs"
                text="This will allow your companies to create custom payment buttons in their Hub."
                translatePrefix="sidebarCollapse."
            />

            {paymentSettings?.allowCustom && (
                <div className="custom-info-wrapper-1">
                    <Info />
                </div>
            )}

            <div className="payment-button-divider"></div>

            <Toggle
                label="Allow renaming in Hub"
                checked={paymentSettings?.allowRename || false}
                callback={() => dispatch(updatePaymentGridSettings({ type: "allowRename", setting: !paymentSettings?.allowRename }))}
            />
            <OliverText
                style={{ maxWidth: "85%" }}
                size="xxs"
                translatePrefix="sidebarCollapse."
                text="This will allow your companies to rename all of their payment buttons in their Hub."
            />

            <div className="payment-button-divider"></div>

            <EditableInfo header="tipsHeader" body="tipsBody" />
        </SidebarCollapse>
    );
};

export default EditPaymentGrid;
